/**
 * Regular expression pattern for dice notation used in Warhammer 40K-style gaming
 *
 * Pattern breakdown:
 * - `([2-9]|[1-9]\\d+)?` - Optional dice count: 2-9 or multi-digit numbers starting with 1-9 (excludes single digit 1)
 * - `(D[36])` - Required die type: D3 or D6 only
 * - `(\\+[1-9]\\d*)?` - Optional positive modifier: +1, +2, etc.
 *
 * @example
 * // Valid matches:
 * "D6"      // Single D6
 * "2D6"     // Two D6s
 * "D3+1"    // D3 with +1 modifier
 * "10D6+5"  // Ten D6s with +5 modifier
 *
 * // Invalid matches:
 * "1D6"     // Single digit 1 not allowed as dice count
 * "D8"      // Only D3 and D6 supported
 * "D6+0"    // Zero modifier not allowed
 * "D6-1"    // Negative modifiers not supported
 */
const regexDiceNotation: string = "([2-9]|[1-9]\\d+)?(D[36])(\\+[1-9]\\d*)?"

export { regexDiceNotation }
